/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetTriggerInstanceSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetTriggerInstanceRequest = {
  /**
   * The trigger instance ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetTriggerInstanceSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetTriggerInstanceSecurity$outboundSchema: z.ZodMiniType<
  GetTriggerInstanceSecurity$Outbound,
  GetTriggerInstanceSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getTriggerInstanceSecurityToJSON(
  getTriggerInstanceSecurity: GetTriggerInstanceSecurity,
): string {
  return JSON.stringify(
    GetTriggerInstanceSecurity$outboundSchema.parse(getTriggerInstanceSecurity),
  );
}

/** @internal */
export type GetTriggerInstanceRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetTriggerInstanceRequest$outboundSchema: z.ZodMiniType<
  GetTriggerInstanceRequest$Outbound,
  GetTriggerInstanceRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getTriggerInstanceRequestToJSON(
  getTriggerInstanceRequest: GetTriggerInstanceRequest,
): string {
  return JSON.stringify(
    GetTriggerInstanceRequest$outboundSchema.parse(getTriggerInstanceRequest),
  );
}
